import { Link, Redirect, useLocation, useHistory } from "react-router-dom";

import AuthLayout, {
  AuthProviderButton,
  FormHeader,
  authProviders,
} from "components/auth/AuthLayout";
import Spacer from "components/global/Spacer";
import { connect } from "react-redux";
import { showAlert } from "utils/utils";
import { useEffect } from "react";
import Logo from "components/global/Logo";
import usePageTitle from "hooks/usePageTitle";
import { store } from "api/store";
import { SET_SHOW_APP_MODAL } from "api/actions/types";
import axios from "axios";

const Login = ({ logged_in, user_accounts, user }) => {
  usePageTitle("Sign in");
  const history = useHistory();
  const { search } = useLocation();
  const add_account = new URLSearchParams(search).get("add_account");
  const redirectPath = new URLSearchParams(search).get("return_to");
  const error = new URLSearchParams(search).get("error");
  const postpaddyMobile = new URLSearchParams(search).get("postpaddy-mobile");

  const handleSocialAuth = async (provider) => {
    const authProviders = ["apple", "google"];
    const url = provider.target;

    if (provider.name === "email") {
      if (postpaddyMobile) {
        history.push(`/sign-in/email?postpaddy-mobile=true`);
      } else {
        history.push(`/sign-in/email${search}`);
      }
      return;
    }

    if (authProviders.includes(provider.name)) {
      window.location.href = url;
      return;
    }

    try {
      const res = await axios.get(url);
      if (res.data?.data?.redirect) {
        localStorage.setItem("redirect", redirectPath);
        localStorage.setItem("socialAuthProvider", provider.name);
        window.location.href = res.data.data.redirect;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const rmCheck = document.getElementById("rememberMe");

    if (error && !logged_in) {
      showAlert({
        msg: error,
        type: "danger",
      });
    }

    if (localStorage.username && localStorage.username !== "") {
      rmCheck?.click();
    }
  }, [error, logged_in]);

  const redirectTo = !user?.has_viewed_tooltips?.onboarding_completed
    ? "/onboarding/create-brand"
    : !user_accounts?.length && !redirectPath?.includes("accept-invite")
    ? "/onboarding/create-brand"
    : user_accounts?.length && !redirectPath?.includes("accept-invite")
    ? redirectPath ?? "/dashboard/home"
    : "/dashboard/home";

  useEffect(() => {
    if (redirectTo.includes("dashboard")) {
      store.dispatch({
        type: SET_SHOW_APP_MODAL,
        payload: true,
      });
    }
  }, [redirectTo]);

  if (user?.email_verified_at && redirectPath?.includes("accept-invite")) {
    return <Redirect to={redirectPath ?? "/dashboard/home"} />;
  }

  if (!add_account && logged_in && user_accounts !== null) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <AuthLayout>
      <FormHeader>
        <Logo />
        <p className="l3">
          Don't have an account?{" "}
          <Link
            to={
              redirectPath
                ? `/sign-up${search}`
                : postpaddyMobile
                ? "/sign-up?postpaddy-mobile=true"
                : "/sign-up"
            }
            className="signInText l3"
          >
            Sign up
          </Link>
        </p>
      </FormHeader>
      <Spacer y={6} yMobile={3.6} />
      <h3 className="title colorGrey1">Welcome back</h3>
      <Spacer y={0.6} />
      <p className="description">Let's get you back into your account</p>
      <Spacer y={2.4} />

      {authProviders.map((provider) => (
        <AuthProviderButton
          key={provider.name}
          type="button"
          onClick={() => {
            if (["facebook", "instagram"].includes(provider.name)) {
              sessionStorage.setItem(
                "return_to",
                `/auth/select-channel/${provider.name}${search}`
              );
            } else {
              sessionStorage.setItem("return_to", `/onboarding${search}`);
            }
            if (
              !!postpaddyMobile ||
              window.location.href.includes("postpaddy-mobile")
            ) {
              localStorage.setItem("authMobileProvider", "true");
            }
            handleSocialAuth(provider);
          }}
        >
          <img src={provider.icon} alt={provider.name} className="icon" />
          <span className="l2">{provider.buttonText}</span>
        </AuthProviderButton>
      ))}
    </AuthLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    logged_in: state.logged_in,
    user_accounts: state.user_accounts,
    user: state.user,
    user_token: state.user_token,
    refresh_token: state.refresh_token,
    expires_in: state.expires_in,
  };
};

export default connect(mapStateToProps)(Login);
